import * as Sentry from '@sentry/nextjs';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  release: '1.0.0',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment:
    process.env.BASE_URL === 'https://filmine.io' ? 'production' : 'not-production',
});
